import React from 'react'

export const Tokenomics = () => {
  return (
    <div className='verifypage'>
        <h3>Comming Soon.....</h3>
    </div>
  )
}
